<!--
 * @Author:
 * @Description: 数据质量评估
-->
<template>
  <el-card class="h-full overflow-y-auto" :body-style="{ padding: '20px', height: '100%' }">
    <div class="text-14px">
      <span>统计周期：</span>
      <el-radio-group class="mr-10px" v-model="period">
        <el-radio v-for="(item, index) in periodList" :key="index" :label="item.value">{{
          item.label
        }}</el-radio>
      </el-radio-group>
      <el-select
        class="w-200px"
        v-model="standardId"
        placeholder="请选择标准库"
        @change="updateStandardId"
        filterable
        clearable
      >
        <el-option
          v-for="item in standardList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button class="ml-10px" type="primary" size="small" @click="toSetting">设置</el-button>
    </div>
    <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px my-10px">质量评分</div>
    <el-row class="h-200px">
      <el-col :span="6" class="h-full text-center">
        <div class="relative w-200px h-full inline-block">
          <img class="h-full inline-block" :src="scoreBgs[scoreSeg].bg" />
          <div class="w-full absolute top-4px">
            <el-progress
              type="dashboard"
              class="square-progress"
              :width="190"
              :percentage="scorePercent"
              :color="scoreColors"
              :show-text="false"
              :stroke-width="16"
              strock-linecap="square"
            ></el-progress>
            <div class="w-full text-center font-bold text-24px !mt-[-110px]">
              <div class="mb-20px text-30px" :style="`color: ${scoreBgs[scoreSeg].color}`">
                {{ scorePercent }}
              </div>
              <div :style="`color: ${scoreBgs[scoreSeg].color}`">
                <span
                  class="border-bottom-4px pb-5px"
                  :style="`border-color: ${scoreBgs[scoreSeg].color}`"
                  >{{ scoreBgs[scoreSeg].text }}</span
                >
              </div>
              <p class="mt-20px font-normal text-16px">评分等级</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="18" class="h-full relative">
        <span
          class="text-[#45a4f9] text-14px absolute right-0 top-0 z-999 cursor-pointer"
          @click="showDimensionTrend()"
          >查看详情>></span
        >
        <v-chart
          ref="lineOption"
          class="h-full w-full"
          :options="dateLineOption"
          :autoresize="true"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </el-col>
    </el-row>
    <div class="my-20px w-full relative">
      <div class="w-full flex justify-between">
        <span
          v-for="(item, index) in scoreBgs"
          :key="index"
          class="text-14px relative"
          :style="`left: ${item.position}; color: ${item.color};`"
        >
          {{ item.text }}
        </span>
      </div>
      <div class="gradient-line w-full my-10px relative">
        <div class="scorePointer" :style="getPosition()"></div>
      </div>
    </div>
    <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px my-10px">
      数据质量维度评分分析
    </div>
    <el-row class="h-360px">
      <el-col :span="18" class="h-full">
        <el-table
          class="mt-10px"
          :data="tableData1"
          v-loading="tableLoading"
          :highlight-current-row="true"
          height="calc(100% - 20px)"
          ref="table"
          :span-method="objectSpanMethod"
          border
        >
          <el-table-column
            v-for="(item, index) in tableHeader1"
            :key="index"
            :label="item.name"
            :prop="item.value"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="item.value === 'weight'">{{ scope.row.weight }}%</span>
              <span v-else>{{ scope.row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="showDimensionTrend(scope.row)">趋势</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          class="mt-20px float-right"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="page1.pageNo"
          :page-size="page1.pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page1.total"
          background
        ></el-pagination> -->
      </el-col>
      <el-col :span="6" class="h-full">
        <v-chart
          ref="dimensionRadarOption"
          class="h-full w-full"
          :options="dimensionRadarOption"
          :autoresize="true"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </el-col>
    </el-row>
    <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px my-10px">
      数据标准库质量评分分析
    </div>
    <el-row class="h-360px">
      <el-col :span="18" class="h-full">
        <el-table
          class="mt-10px"
          :data="tableData2"
          v-loading="tableLoading"
          :highlight-current-row="true"
          height="calc(100% - 20px)"
          ref="table"
          border
        >
          <el-table-column
            v-for="(item, index) in tableHeader2"
            :key="index"
            :label="item.name"
            :prop="item.value"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="showStandardTrend(scope.row)">趋势</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="6" class="h-full">
        <v-chart
          ref="qualityAnalysisBarOption"
          class="h-full w-full"
          :options="qualityAnalysisBarOption"
          :autoresize="true"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="h-360px">
      <el-col :span="12" class="h-full">
        <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px my-10px">
          数据实体质量评分Bot5排行
        </div>
        <el-table
          class="mt-10px"
          :data="tableData3"
          v-loading="tableLoading"
          :highlight-current-row="true"
          height="calc(100% - 50px)"
          ref="table"
          border
        >
          <el-table-column
            v-for="(item, index) in tableHeader3"
            :key="index"
            :label="item.name"
            :prop="item.value"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12" class="h-full">
        <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px my-10px">
          数据实体质量评分Top5排行
        </div>
        <el-table
          class="mt-10px"
          :data="tableData4"
          v-loading="tableLoading"
          :highlight-current-row="true"
          height="calc(100% - 50px)"
          ref="table"
          border
        >
          <el-table-column
            v-for="(item, index) in tableHeader3"
            :key="index"
            :label="item.name"
            :prop="item.value"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 质量维度趋势弹框 -->
    <el-dialog
      :close-on-click-modal="true"
      :visible.sync="dimensionTrendVisible"
      :title="dimensionTrendTitle"
      @close="closeDimensionTrendDialog"
      width="1200px"
      heigth="100%"
      v-dialogDrag
    >
      <div class="mb-20px">
        <span>数据标准库：</span>
        <el-select
          class="w-200px"
          v-model="trendStandardId"
          placeholder="请选择标准库"
          @change="searchDimensionTrend(trendType)"
          filterable
          clearable
        >
          <el-option
            v-for="item in standardList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="ml-10px">时间间隔：</span>
        <el-date-picker
          v-model="trendTimeRange"
          :type="datePickerType"
          popper-class="date-clear"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="searchDimensionTrend(trendType)"
          :picker-options="pickerOptions"
          :clearable="false"
        ></el-date-picker>
        <el-button
          class="ml-10px"
          type="primary"
          size="small"
          @click="searchDimensionTrend(trendType)"
          >查询</el-button
        >
      </div>
      <div class="h-400px">
        <v-chart
          id="trendlineOption1"
          class="h-full w-full"
          :options="qualityScoreLineTrendOptions"
          :autoresize="true"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="closeDimensionTrendDialog">确定</el-button>
        <el-button @click="closeDimensionTrendDialog">取消</el-button>
      </div>
    </el-dialog>
    <!-- 标准库质量评分趋势弹框 -->
    <el-dialog
      :close-on-click-modal="true"
      :visible.sync="standardTrendVisible"
      title="趋势"
      @close="closeStandardTrendDialog"
      width="1200px"
      heigth="100%"
      v-dialogDrag
    >
      <div class="mb-20px">
        <span>数据标准库：</span>
        <el-select
          class="w-200px"
          v-model="trendStandardId"
          placeholder="请选择标准库"
          filterable
          clearable
        >
          <el-option
            v-for="item in standardList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="ml-10px">时间间隔：</span>
        <el-date-picker
          v-model="trendTimeRange"
          :type="datePickerType"
          popper-class="date-clear"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="searchStandardTrend"
          :picker-options="pickerOptions"
          :clearable="false"
        ></el-date-picker>
        <el-button class="ml-10px" type="primary" size="small" @click="searchStandardTrend"
          >查询</el-button
        >
      </div>
      <div class="h-400px">
        <v-chart
          id="trendlineOption2"
          class="h-full w-full"
          :options="qualityScoreLineTrendOptions"
          :autoresize="true"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="closeStandardTrendDialog">确定</el-button>
        <el-button @click="closeStandardTrendDialog">取消</el-button>
      </div>
    </el-dialog>
    <!-- 设置弹框 -->
    <qualityAssessmentSetting
      :settingDialogVisible="settingDialogVisible"
      @closeDialog="closeSettingDialog"
    />
  </el-card>
</template>

<script>
import StandardManagementService from '@/services/common/StandardManagementService'
import dataQualityAssessmentService from '@/services/DataQualityAssessmentService'
import charts from '../../components/model/js/charts'
import qualityAssessmentSetting from './components/qualityAssessmentSetting'

export default {
  name: 'dataQualityAssessment',
  components: { qualityAssessmentSetting },
  data() {
    return {
      standardList: [],
      standardId: '',
      period: 0,
      periodList: [
        { label: '今日', value: 0 },
        { label: '昨日', value: 1 },
        { label: '本周', value: 2 },
        { label: '本月', value: 3 },
        { label: '本年', value: 4 },
      ],
      dateLineOption: _.cloneDeep(charts.qualityScoreLineOption),
      dimensionRadarOption: _.cloneDeep(charts.dimensionRadarOption),
      qualityAnalysisBarOption: _.cloneDeep(charts.qualityAnalysisBarOption),
      scorePercent: 0,
      scoreColors: [
        { color: '#ff2f2a', percentage: 20 },
        { color: '#f89b44', percentage: 40 },
        { color: '#f7ca3b', percentage: 60 },
        { color: '#0dcbf5', percentage: 80 },
        { color: '#56d566', percentage: 100 },
      ],
      scoreBgs: [
        {
          bg: require('../../assets/images/Group1.png'),
          text: '极差',
          color: '#ff5f5b',
          position: '0%',
        },
        {
          bg: require('../../assets/images/Group2.png'),
          text: '较差',
          color: '#f9a76c',
          position: '8%',
        },
        {
          bg: require('../../assets/images/Group3.png'),
          text: '合格',
          color: '#fad468',
          position: '-1%',
        },
        {
          bg: require('../../assets/images/Group4.png'),
          text: '良好',
          color: '#28d3fe',
          position: '-5%',
        },
        {
          bg: require('../../assets/images/Group5.png'),
          text: '优秀',
          color: '#57d564',
          position: '0%',
        },
      ],
      scoreSeg: 0,
      tableLoading: false,
      // 维度评分列表
      tableHeader1: [
        { name: '数据质量维度', value: 'qualityDimensionName' },
        { name: '质量评分', value: 'score' },
        { name: '权重', value: 'weight' },
        { name: '质量规则', value: 'dataRuleTypeName' },
        { name: '评估实体数量', value: 'classNumber' },
        { name: '数据量', value: 'dataNumber' },
        { name: '评估时间', value: 'dateTime' },
      ],
      tableData1: [],
      page1: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      // 标准库质量评分列表
      tableHeader2: [
        { name: '数据标准库', value: 'standardName' },
        { name: '质量评分', value: 'score' },
        { name: '评估实体数量', value: 'classCount' },
        { name: '质检任务数量', value: 'taskCount' },
        { name: '质检规则数量', value: 'ruleCount' },
        { name: '质检数据量', value: 'dataCount' },
        { name: '评估时间', value: 'evaluateTime' },
      ],
      tableData2: [],
      // 实体质量评分Bot5/Top5排行
      tableHeader3: [
        { name: '中文名称', value: 'className' },
        { name: '英文名称', value: 'classCode' },
        { name: '质量评分', value: 'score' },
        { name: '规则数', value: 'ruleNumber' },
        { name: '主题域', value: 'theme' },
        { name: '来源系统', value: 'sourceSystem' },
      ],
      tableData3: [],
      tableData4: [],
      settingDialogVisible: false,
      startTime: null,
      endTime: null,
      dimensionTrendVisible: false,
      trendTimeRange: [],
      qualityScoreLineTrendOptions: _.cloneDeep(charts.qualityScoreLineOption),
      trendStandardId: '',
      trendDetail: {},
      standardTrendVisible: false,
      dimensionTrendTitle: '',
      trendType: '',
      datePickerType: 'datetimerange',
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > new Date().getTime()
        // },
      },
      chartLine: null,
    }
  },
  computed: {},
  watch: {
    period: {
      deep: true,
      immediate: true,
      handler(val) {
        // console.log(val, '111')
        this.getPeriodTime(val)
        this.getDataQualityStatistics()
        this.getDimensionScoreList()
        this.getstandardScoreAnalysis()
        this.getClassStatistics()
      },
    },
  },
  created() {
    this.getStandardList()
    this.getDateStatistics()
  },
  mounted() {},
  methods: {
    // 判断浮标位置
    getPosition() {
      if (this.scorePercent <= 50) {
        return `left: ${this.scorePercent}%`
      }
      return `right: ${100 - this.scorePercent}%`
    },
    // 获取标准库
    async getStandardList() {
      this.standardList = []
      const res = await StandardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = _.map(res.data, (item) => {
          return {
            name: item.name,
            code: item.code,
            id: item.id,
          }
        })
      }
    },
    // 标准库变更
    updateStandardId(val) {
      this.standardId = val
      this.getDataQualityStatistics()
      this.getDateStatistics()
      this.getDimensionScoreList()
      this.getstandardScoreAnalysis()
      this.getClassStatistics()
    },
    // 获取质量评分统计数据
    async getDataQualityStatistics() {
      const res = await dataQualityAssessmentService.getDataQualityStatistics({
        standardId: this.standardId,
        period: this.period,
      })
      if (res && res.code === 0 && res.data) {
        this.scorePercent = res.data.score
        this.getScoreSegment(this.scorePercent)
        // 处理维度统计雷达图
        this.dimensionRadarOption.series[0].data[0].value = [0, 0, 0, 0, 0]
        this.dimensionRadarOption.radar.indicator = [
          { name: '规范性', max: 100 },
          { name: '一致性', max: 100 },
          { name: '准确性', max: 100 },
          { name: '完整性', max: 100 },
          { name: '唯一性', max: 100 },
        ]
        if (res.data.dimensionStatistics?.length) {
          this.dimensionRadarOption.series[0].data[0].value = []
          this.dimensionRadarOption.radar.indicator = []
          res.data.dimensionStatistics.forEach((item) => {
            this.dimensionRadarOption.series[0].data[0].value.push(item.score)
            this.dimensionRadarOption.radar.indicator.push({ name: item.dimensionName, max: 100 })
          })
        }
        // 处理标准统计柱状图
        this.qualityAnalysisBarOption.xAxis.data = []
        this.qualityAnalysisBarOption.series[0].data = []
        if (res.data.standardStatistics?.length) {
          res.data.standardStatistics.forEach((item) => {
            this.qualityAnalysisBarOption.xAxis.data.push(item.standardName)
            this.qualityAnalysisBarOption.series[0].data.push(item.score)
          })
        }
      }
    },
    // 获取时间统计曲线图数据
    async getDateStatistics() {
      const res = await dataQualityAssessmentService.getDateStatistics({
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        // 处理日期曲线图数据
        this.dateLineOption.series[0].data = []
        this.dateLineOption.xAxis.data = []
        if (res.data.dateStatistics?.length) {
          res.data.dateStatistics.forEach((item) => {
            this.dateLineOption.series[0].data.push(item.score)
            this.dateLineOption.xAxis.data.push(moment(item.date).format('YYYY-MM-DD'))
          })
        }
      }
    },
    // 获取质量维度评分列表
    async getDimensionScoreList() {
      this.tableData1 = []
      this.tableLoading = true
      const res = await dataQualityAssessmentService.getDimensionScoreList({
        standardId: this.standardId,
        period: this.period,
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        res.data.forEach((item) => {
          let obj = {}
          if (item.stdDataQualityRuleScoreDtos.length) {
            item.stdDataQualityRuleScoreDtos.forEach((val) => {
              obj = {
                ...item,
                dataRuleTypeName: val.dataRuleTypeName,
                dataNumber: val.dataNumber,
                dateTime: val.dateTime,
                classNumber: val.classNumber,
              }
              this.tableData1.push(obj)
            })
          } else {
            this.tableData1.push(item)
          }
        })
      }
      this.tableLoading = false
    },
    // 获取标准库质量评分列表
    async getstandardScoreAnalysis() {
      const res = await dataQualityAssessmentService.getstandardScoreAnalysis({
        standardId: this.standardId,
        period: this.period,
      })
      if (res && res.code === 0 && res.data) {
        this.tableData2 = res.data
      }
    },
    // 获取质量维度评分列表数据
    async getClassStatistics() {
      const res = await dataQualityAssessmentService.getClassStatistics({
        standardId: this.standardId,
        period: this.period,
      })
      if (res && res.code === 0 && res.data) {
        this.tableData3 = res.data?.botRanking
        this.tableData4 = res.data?.topRanking
      }
    },
    // 获取质量评分段
    getScoreSegment(score) {
      switch (true) {
        case score >= 0 && score < 20:
          this.scoreSeg = 0
          break
        case score >= 20 && score < 40:
          this.scoreSeg = 1
          break
        case score >= 40 && score < 60:
          this.scoreSeg = 2
          break
        case score >= 60 && score < 80:
          this.scoreSeg = 3
          break
        case score >= 80 && score <= 100:
          this.scoreSeg = 4
          break
        default:
          break
      }
    },
    // 设置
    toSetting() {
      this.settingDialogVisible = true
    },
    // 关闭设置弹框
    closeSettingDialog(val) {
      this.settingDialogVisible = val
    },
    // 周期转换时间
    getPeriodTime(period) {
      switch (period) {
        case 0:
          this.startTime = moment().format('YYYY-MM-DD')
          this.endTime = moment().format('YYYY-MM-DD')
          break
        case 1:
          this.startTime = moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD')
          this.endTime = moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD')
          break
        case 2:
          this.startTime = moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD')
          this.endTime = moment().format('YYYY-MM-DD')
          break
        case 3:
          this.startTime = moment()
            .subtract(1, 'M')
            .format('YYYY-MM-DD')
          this.endTime = moment().format('YYYY-MM-DD')
          break
        case 4:
          this.startTime = moment()
            .subtract(1, 'y')
            .format('YYYY-MM-DD')
          this.endTime = moment().format('YYYY-MM-DD')
          break
        default:
          break
      }
    },

    // 打开【趋势】弹框
    async showDimensionTrend(row) {
      this.dimensionTrendVisible = true
      this.qualityScoreLineTrendOptions.series = []
      if (row) {
        // 维度趋势
        this.trendDetail = row
        this.trendTimeRange = this.setTrendTimeRange(this.period)
        this.dimensionTrendTitle = '趋势'
        this.trendType = ''
        this.searchDimensionTrend(this.trendType)
      } else {
        // 日期评分趋势
        this.dimensionTrendTitle = '查看详情'
        this.datePickerType = 'datetimerange'
        this.trendTimeRange = [
          `${moment()
            .subtract(6, 'days')
            .format('YYYY-MM-DD')} 00:00:00`,
          `${moment().format('YYYY-MM-DD')} 00:00:00`,
        ]
        this.trendType = 'detail'
        this.searchDimensionTrend(this.trendType)
      }
    },
    // 查询趋势
    async searchDimensionTrend(type) {
      this.qualityScoreLineTrendOptions.series = []
      let res = null
      if (type === 'detail') {
        // 查询时间评分趋势
        res = await dataQualityAssessmentService.getDateScoreTrend({
          standardId: this.trendStandardId,
          beginTime: this.trendTimeRange[0],
          endTime: this.trendTimeRange[1],
        })
      } else {
        // 查询维度趋势
        res = await dataQualityAssessmentService.getDimensionScoreTrend({
          standardId: this.trendStandardId,
          beginTime: this.trendTimeRange[0],
          endTime: this.trendTimeRange[1],
          qualityDimensionId: this.trendDetail.qualityDimensionId,
          period: this.period,
        })
      }
      if (res && res.code === 0 && res.data && res.data.length) {
        this.chartLine = this.$echarts.init(document.getElementById('trendlineOption1'))
        this.chartLine.clear() // 重新绘制图表
        this.setTrendOptions(res.data)
      }
    },
    // 关闭质量维度趋势弹框
    closeDimensionTrendDialog() {
      this.dimensionTrendVisible = false
      this.trendStandardId = ''
      this.trendTimeRange = []
    },

    // 打开【标准库质量评分】趋势弹框
    showStandardTrend(row) {
      this.standardTrendVisible = true
      this.trendDetail = row
      this.trendTimeRange = this.setTrendTimeRange(this.period)
      this.searchStandardTrend()
    },
    // 查询标准库质量评分趋势
    async searchStandardTrend() {
      const res = await dataQualityAssessmentService.getStandardScoreTrend({
        standardId: this.trendStandardId || this.trendDetail.standardId,
        beginTime: this.trendTimeRange[0],
        endTime: this.trendTimeRange[1],
        period: this.period,
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        this.chartLine = this.$echarts.init(document.getElementById('trendlineOption2'))
        this.chartLine.clear() // 重新绘制图表
        this.setTrendOptions(res.data)
      }
    },
    // 关闭标准库质量评分趋势弹框
    closeStandardTrendDialog() {
      this.standardTrendVisible = false
      this.trendStandardId = ''
      this.trendTimeRange = []
    },
    // 按选中的周期设置默认时间
    setTrendTimeRange(period) {
      let timeRange = []
      this.datePickerType = 'datetimerange'
      if (period === 0 || period === 1 || period === 2) {
        // 今日、昨日、本周
        timeRange = [
          `${moment()
            .subtract(6, 'days')
            .format('YYYY-MM-DD')} 00:00:00`,
          `${moment().format('YYYY-MM-DD')} 00:00:00`,
        ]
      } else if (period === 3) {
        // 按月
        timeRange = [
          `${moment()
            .subtract(1, 'months')
            .format('YYYY-MM-DD')} 00:00:00`,
          `${moment().format('YYYY-MM-DD')} 00:00:00`,
        ]
      } else if (period === 4) {
        // 按年
        timeRange = [
          `${moment()
            .subtract(1, 'years')
            .format('YYYY-MM-DD')} 00:00:00`,
          `${moment().format('YYYY-MM-DD')} 00:00:00`,
        ]
        this.datePickerType = 'monthrange'
      }
      return timeRange
    },
    // 趋势图设置
    setTrendOptions(data) {
      // console.log(data, '111')
      this.qualityScoreLineTrendOptions.xAxis.axisTick.show = true // 显示刻度线
      this.qualityScoreLineTrendOptions.series = []
      this.qualityScoreLineTrendOptions.legend.data = []

      data.forEach((item) => {
        this.qualityScoreLineTrendOptions.legend.data.push(item.standardName)
        this.qualityScoreLineTrendOptions.xAxis.data = []
        const series = {
          name: item.standardName,
          data: [0, 0, 0, 0, 0, 0, 0],
          type: 'line',
          smooth: true,
          symbolSize: 8,
        }
        series.data = []
        item.scores.forEach((val) => {
          this.qualityScoreLineTrendOptions.xAxis.data.push(val.date)
          series.data.push(val.score)
        })
        this.qualityScoreLineTrendOptions.series.push(series)
        if (this.qualityScoreLineTrendOptions.xAxis.data.length > 7) {
          this.qualityScoreLineTrendOptions.xAxis.axisLabel.rotate = 45 // 横向标签旋转45度
          this.qualityScoreLineTrendOptions.grid.bottom = 60 // 底部留白
        } else {
          this.qualityScoreLineTrendOptions.xAxis.axisLabel.rotate = 0
          this.qualityScoreLineTrendOptions.grid.bottom = 20
        }
      })
    },
    // 质量维度评分列表合并单元格
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if ([0, 1, 2, 7].includes(columnIndex)) {
        if (
          rowIndex === 0 ||
          this.tableData1[rowIndex - 1].qualityDimensionId !== row.qualityDimensionId
        ) {
          const rowSpan = this.tableData1.filter((item) => {
            return item.qualityDimensionId === row.qualityDimensionId
          }).length
          return {
            rowspan: rowSpan,
            colspan: 1,
          }
        }
        return {
          rowspan: 0,
          colspan: 1,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
  },
}
</script>

<style lang="scss" scoped>

/deep/.el-progress-circle__track {
  stroke: transparent !important;
}
/deep/.el-progress-bar__inner,
/deep/.el-progress-bar {
  border-radius: 0 !important;
}
.square-progress .el-progress-bar__inner {
  border-radius: 0 !important;
}
.date-clear .el-picker-panel__footer .el-picker-panel__link-btn.el-button--text {
  display: none !important;
}
.gradient-line {
  height: 10px;
  border-radius: 10px;
  background-image: linear-gradient(
    to right,
    #ff2e29 10%,
    #f9a76c 30%,
    #fad468 50%,
    #28d3fe 70%,
    #57d564 100%
  );
}
.scorePointer {
  width: 20px;
  height: 20px;
  background: #ffe500;
  border: 2px solid #fff;
  border-radius: 50%;
  position: absolute;
  bottom: -4px;
}

</style>
